import PageLayout from "components/PageLayout";

const CaseStudies = () => {
    return (
      <PageLayout pageTitle={"Case Studies"}
        pageSubtitle={"These case studies present the results of applying ThermalPoint to real homes. Utility consumption data was collected before and after heat pump installations in several homes along with smart thermostat data. This information was used to assess the accuracy of ThermalPoint tool in predicting TBPT."}>
          <a href="https://sustainabletechnologies.ca/reports/thermalpoint-case-study-1/" target="_blank" rel="noopener noreferrer">
            <h3>Case Study 1</h3>
          </a>
          <a href="https://sustainabletechnologies.ca/reports/thermalpoint-case-study-2/" target="_blank" rel="noopener noreferrer">
            <h3>Case Study 2</h3>
          </a>
          <p></p>
      </PageLayout>
    );
  };
  
  export default CaseStudies;